import React from 'react';
import { ENGAGE_STEPS } from '../data/capabilities';
import AnimatedSection from './AnimatedSection';
import './EngageSection.css';

const EngageSection = () => (
  <section className="engage section">
    <div className="container">
      <AnimatedSection>
        <p className="section-label">/ How we engage</p>
        <h2 className="section-title">Scope. Build. Harden.</h2>
        <p className="section-subtitle">
          One problem at a time — from a measurable pilot to something operators depend on.
        </p>
      </AnimatedSection>

      <ol className="engage-steps">
        {ENGAGE_STEPS.map((step, i) => (
          <AnimatedSection key={step.n} delay={i * 0.07} as="li" className="engage-step">
            <span className="engage-n">{step.n}</span>
            <h3>{step.title}</h3>
            <p>{step.text}</p>
          </AnimatedSection>
        ))}
      </ol>
    </div>
  </section>
);

export default EngageSection;
